/**
 * One toast per action (Ryan, 28 Oct). The server confirms every lesson it
 * books with a notification (booking_confirmed), which the app shows as a
 * toast. Where the action already says it, those stay quiet: the Booked page
 * for the lesson just booked, and "Weekly time set: every Monday at 8:30 PM"
 * for the lessons a weekly time books and the server's one notice of them
 * (weekly_time_held). A notice of holds at a renewal, with nothing set here,
 * still shows.
 */

const BOOKED_HERE = (id: string) => `db.bookedHere.${id}`;
const QUIET_UNTIL = 'db.quietBookingsUntil';
/** How long a weekly time's own bookings stay quiet after it is set. */
export const QUIET_MS = 2 * 60_000;

/** The one toast for a weekly time: "Weekly time set: every Monday at 8:30 PM". */
export function weeklyTimeToast(line: string): string {
  return `Weekly time set: ${line.replace(/^Every\b/, 'every').replace(/\.$/, '')}`;
}

/** Whether a notification's toast is one the action already said. */
export function skipsToast(
  n: { link?: string; data?: unknown },
  ctx: { nowMs: number; quietUntil: number | null; bookedHere: (bookingId: string) => boolean },
): boolean {
  const event = (n.data as { liveEvent?: string } | undefined)?.liveEvent;
  // The weekly time contract's one notice per set (weekly_time_held) is its toast's too.
  if (event === 'weekly_time_held') return ctx.quietUntil != null && ctx.nowMs < ctx.quietUntil;
  if (event !== 'booking_confirmed') return false;
  if (ctx.quietUntil != null && ctx.nowMs < ctx.quietUntil) return true;
  const id = n.link?.match(/^\/call\/([^/?#]+)/)?.[1];
  return !!id && ctx.bookedHere(id);
}

// This device's marks, kept for the session.
const read = (key: string) => { try { return sessionStorage.getItem(key); } catch { return null; } };
const write = (key: string, value: string) => { try { sessionStorage.setItem(key, value); } catch { /* the toast shows */ } };

export const markBookedHere = (bookingId: string) => write(BOOKED_HERE(bookingId), '1');
export const bookedHere = (bookingId: string) => read(BOOKED_HERE(bookingId)) === '1';
/** A weekly time is being set: its bookings' toasts stay quiet a while. */
export const markBookingsQuiet = (nowMs = Date.now()) => write(QUIET_UNTIL, String(nowMs + QUIET_MS));
export const quietUntil = (): number | null => { const v = Number(read(QUIET_UNTIL)); return v > 0 ? v : null; };
